// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sk-spinner {
  color: #333;
}

.sk-spinner > div {
  background-color: currentColor;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-spinkit/css/base.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".sk-spinner {\n  color: #333;\n}\n\n.sk-spinner > div {\n  background-color: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
